<!-- Breadcrumb -->
<div class="pag-container">

  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>


  <div class="ui-g-12 d-flex justify-content-center">
    <div class="highlight-section">
      <span class="title-span">
        {{ 'notification.select_interval_text' | translate }}
      </span>
    </div>
  </div>


  <div class="ui-g-12">
    <div class="ui-g-6 d-flex align-items-center" style="margin-top: 20px; gap: 12px;">
      <h2 class="title">{{ 'notification.notification_list' | translate }}</h2>
<!--       <span class="title-span">{{ 'notification.select_interval' | translate }}</span>
 -->    </div>
    <div class="ui-g-3 dateFilters">

      <app-form-fields #end_date data-testid="start_date" [showRequiredAsterix]="true"
        [label]="'notification.from_start_date' | translate" [required]="true" [(fieldModel)]="startDate"
        [type]="'date'" [placeholder]="'notification.select_end_date' | translate"></app-form-fields>
    </div>

    <div class="ui-g-3 dateFilters">

      <app-form-fields #end_date data-testid="end_date" [showRequiredAsterix]="true"
        [label]="'notification.to_end_date' | translate" [required]="true" [(fieldModel)]="endDate" [type]="'date'"
        [placeholder]="'notification.select_end_date' | translate"></app-form-fields>
    </div>

  </div>

  <div class="ui-g-12">

    <app-campaign-3-kontable *ngIf="readyTable" #notificationManager [columns]="[

 
  {
    field: 'challengeId',
    title: 'notification.challengeId',
    filterType: textFilter
  },

  {
    field: 'message',
    title: 'notification.message',
    filterType: textFilter
  },

  {
    field: 'headId',
    title: 'notification.headId',
    filterType: textFilter
  },

  {
    field: 'hostId',
    title: 'notification.hostId',
    filterType: textFilter
  },

  {
    field: 'notifyAt',
    title: 'notification.notifyAt',
    filterType: textFilter,
    bodyTemplate: notifyAtTemplate
  },

  {
    field: 'operationTakenOn',
    title: 'notification.operationTakenOn',
    filterType: textFilter,
    bodyTemplate: operationTemplate
  },

  {
    field: 'status',
    title: 'notification.status',
     filterType: selectFilter,
      filterOptions: { values: statusList },
    bodyTemplate: statusTemplate
  }

  ]" [service]="notificationService" [paginationType]="paginationType" [additionalRowCommands]="actions"
      [expandTable]="true" [fetchActionListAsap]="false" [subjectToLoad]="pageSubject" [filterBySingleColumn]="false"
      [showRecoverButton]="false" [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false"
      [showDetailsButton]="false" [showEditButton]="false" [showGlobalFilter]="true"
      [customExpandedRowTemplate]="customTemplate" [fetchNotificationDetailAsap]="true" [filterStartDate]="startDate"
      [filterEndDate]="endDate">


      <ng-template #customTemplate let-row let-notificationDetail="notificationDetail">
        <app-notification-details [scheduleResponse]="notificationDetail" [fatherNotification]="row">
        </app-notification-details>
      </ng-template>
      <ng-template #notifyAtTemplate let-row>
        <span class="center-number">
          {{ row.notifyAt | date:srvCalendar.pcalendarTranslate.dateFormatFilter }}
        </span>
      </ng-template>

      <ng-template #operationTemplate let-row>
        <span class="center-number">
          {{ row.operationTakenOn ? 'YES' : 'NO' }}
        </span>
      </ng-template>

      <ng-template #statusTemplate let-row>
        <span class="status-badge" [ngClass]="{
      'status-green':   getStatusColor(row.status) === StatusColor.GREEN,
      'status-orange':  getStatusColor(row.status) === StatusColor.ORANGE,
      'status-red':     getStatusColor(row.status) === StatusColor.RED,
      'status-unknown': getStatusColor(row.status) === StatusColor.UNKNOWN
    }">
          {{ 'scheduleStatus.' + row.status | translate }}
        </span>
      </ng-template>
      <ng-template #actions let-row>
        <div class="d-flex justify-content-center">

          <button data-testid-generic="notificationActions" [attr.data-testid]="'notificationActions' + row.id"
            pTooltip="{{ 'common.actions' | translate }}" class="roundedButton" (click)="toggleMenu(row)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>
        </div>
        <div class="dropdown-menu" *ngIf="showMenu && row.challengeId == currentOpenedRow">


          <!-- VIEW STATUS -->
          <button *ngIf="hasCommand(row.status, notificationCommand.VIEW_STATUS)"
            data-testid-generic="viewNotificationStatus" class="dropdown-item-creation"
            (click)="openNotificationStatus(row)">
            {{ 'common.view_status' | translate }}
          </button>

          <!-- DELETE -->
          <button *ngIf="hasCommand(row.status, notificationCommand.DELETE)" data-testid-generic="deleteNotification"
            class="dropdown-item-creation" (click)="deleteNotification(row)">
            {{ 'common.delete' | translate }}
          </button>

          <!-- RESEND -->
          <button *ngIf="hasCommand(row.status, notificationCommand.RESEND)" data-testid-generic="resendNotification"
            class="dropdown-item-creation" (click)="resendNotification(row)">
            {{ 'common.resend' | translate }}
          </button>

        </div>
      </ng-template>
    </app-campaign-3-kontable>
  </div>

</div>


<p-dialog header="{{ 'campaign.confirm_delete' | translate }}" [(visible)]="displayDeleteDialog" [modal]="true"
  [closable]="false" class="custom-dialog">

  <div>{{ 'notification.confirm_delete_message' | translate }} {{ notificationToDelete?.name }}</div>

  <div class="custom-footer">
    <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()"
      icon="pi pi-times"></button>
    <button type="button" pButton label="{{ 'common.confirm' | translate }}"
      (click)="onDefinitiveDelete(notificationToDelete)" icon="pi pi-check" style="margin-left: .25em"></button>
  </div>
</p-dialog>


<p-dialog *ngIf="showNotificationStatusModal" [(visible)]="showNotificationStatusModal" [modal]="true"
  [responsive]="true" [width]="800" [header]="'notification.status_detail' | translate" showEffect="fade"
  (onHide)="closeNotificationStatusModal()">

  <app-notification-popup-menu
  [row]="selectedNotificationRow"
  [visible]="showNotificationStatusModal"
   (onClose)="closeNotificationStatusModal()">
</app-notification-popup-menu>
</p-dialog>

<footer></footer>


// WEBPACK FOOTER //
// ./src/app/views/notification/notification-management.component.html